import React, { useState,useEffect } from 'react';
import { DownloadFile } from './Function';
import { Row,Col,Card,Placeholder,Button } from 'react-bootstrap';
const FacilitiesForms = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[MiscellaneousType,setMiscellaneousType]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousType = async () => 
        {
            setLoading(true);
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneousType/byId/12");
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.mt_id + "/miscImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.mt_id + "/miscImageHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].miscImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].miscImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setMiscellaneousType(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('MiscellaneousType File :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setMiscellaneousType([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('MiscellaneousType : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousType : Error', error.message);
            }
        };
        MiscellaneousType();
    },[])
    return (
        <React.Fragment>              
        {isLoading ? ( 
            <Card className=' mb-4'>
                <Card.Header className='text-center fs-3 text-uppercase'><Placeholder xs={10} /></Card.Header>
                <Card.Body>
                    <Row className='g-3'>
                        {[...Array(6)].map((_,index)=>(
                        <Col md={4} key={index} >
                            <Card className="text-bg-dark text-center" data-aos="flip-up" data-aos-duration="1000">
                                <Placeholder xs={12} style={{height:"200px"}} />
                                <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center bg-dark bg-opacity-75'>
                                    <Card.Title className='w-100'><Placeholder xs={12} bg="light" /></Card.Title>
                                    <Button className="btn btn-light w-50"><Placeholder xs={10} /></Button>
                                </Card.ImgOverlay>
                            </Card>
                        </Col>
                        ))}
                    </Row>
                </Card.Body>
            </Card>
        ) : (
            <React.Fragment>
            {MiscellaneousType.map((mt,index)=>(
            <Card className=' mb-4' key={index}>
                <Card.Header className='text-center fs-3 text-uppercase'>
                    {appLanguage === 'hi' ? 'फॉर्म डाउनलोड करें' : 'Download The Forms' }
                </Card.Header>
                <Card.Body>
                    <MiscellaneousList mtId={mt.mt_id} mtImage={ appLanguage === 'hi' ? mt.miscImageHi || mt.miscImage : mt.miscImage } />
                </Card.Body>
            </Card>
            ))}
            </React.Fragment>
        )}
        <Card className=' mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase'>
                {appLanguage === 'hi' ? 'लाइब्रेरी फॉर्म' : 'LIBRARY FORMS'}
            </Card.Header>
            <Card.Body className='bg-success bg-opacity-25'>
                <Card className="border-dark my-4 ">
                    <Card.Body>
                        <ul className="list-unstyled">
                            <li className="text-justify d-flex" data-aos="flip-up" data-aos-duration="1000">
                                <i className="bi bi-chevron-double-right me-2"></i>
                                {appLanguage === 'hi' ? (
                                    <p>सभी संकाय सदस्यों, शोधार्थियों या किसी छात्र को सदस्यता स्वतः ही प्रदान कर दी जाती है और यह सदस्यता उसके पूरे कार्यकाल के लिए वैध रहती है। सदस्यों को संस्थान में शामिल होने के बाद विधिवत भरा हुआ पंजीकरण प्रस्तुत करना चाहिए जिसे सर्कुलेशन काउंटर से प्राप्त किया जा सकता है या यहाँ से डाउनलोड भी किया जा सकता है।</p>
                                ) : (
                                    <p>Membership is automatically conferred to all the faculty members, research scholars or a student on his / her joining and remains valid for his full tenure. Members should present duly filled in registration from upon joining the institute which can be obtained from the Circulation Counter or download from here.</p>
                                )}                                
                            </li>
                            <li className="text-justify d-flex" data-aos="flip-up" data-aos-duration="1000">
                                <i className="bi bi-chevron-double-right me-2"></i>
                                {appLanguage === 'hi' ? (
                                    <p>संस्थान छोड़ते समय एलआरसी से नो ड्यूज सर्टिफिकेट/क्लीयरेंस सर्टिफिकेट प्राप्त किया जाना चाहिए। जब ​​तक सभी उधार वापस नहीं कर दिए जाते, तब तक परिणाम या डिग्री या बकाया राशि सदस्यों को जारी नहीं की जा सकती।</p>
                                ) : (
                                    <p>No Dues Certificate / Clearance Certificate should be obtained from the LRC while leaving the Institute. Result or degree or dues cannot be released to members, unless all borrowings are returned.</p>
                                )}                                
                            </li>
                            <li className="text-justify d-flex" data-aos="flip-up" data-aos-duration="1000">
                                <i className="bi bi-chevron-double-right me-2"></i>
                                {appLanguage === 'hi' ? (
                                    <p className="mb-0">एलआरसी सदस्यता कार्ड के खो जाने/क्षतिग्रस्त हो जाने पर, पुलिस स्टेशन से एफआईआर की प्रति प्रस्तुत करने पर 100/- रुपये के अतिरिक्त डुप्लीकेट कार्ड जारी किया जाएगा।</p>
                                ) : (
                                    <p className="mb-0">For loss/damage of LRC Membership card, Duplicate card will be issued @ Rs.100/- plus on production of FIR copy from the Police Station.</p>
                                )}                                
                            </li>
                        </ul>
                    </Card.Body>
                </Card>
            </Card.Body>
        </Card>
        </React.Fragment>
    );
}
export default FacilitiesForms;
const MiscellaneousList = ({mtId,mtImage}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Miscellaneous,setMiscellaneous]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousByType = async () => 
        {
            setLoading(true);
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneous/byTypeAll/"+mtId);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFileHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].miscFile = el.upp;
                            result[i].miscFileHi = el.upb;
                        });
                        setMiscellaneous(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('Miscellaneous File :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setMiscellaneous([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('MiscellaneousByType : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousByType : Error', error.message);
            }
        };
        MiscellaneousByType();   
    },[mtId,mtImage])
    return (
        <React.Fragment>
        {isLoading ? (
            <Row className='g-3'>
                {[...Array(6)].map((_,index)=>(
                <Col md={4} key={index} >
                    <Card className="text-bg-dark text-center" data-aos="flip-up" data-aos-duration="1000">
                        <Placeholder xs={12} style={{height:"200px"}} />
                        <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center bg-dark bg-opacity-75'>
                            <Card.Title className='w-100'><Placeholder xs={12} bg="light" /></Card.Title>
                            <Button className="btn btn-light w-50"><Placeholder xs={10} /></Button>
                        </Card.ImgOverlay>
                    </Card>
                </Col>
                ))}
            </Row>   
            ) : (
            <Row className='g-3'>
                {Miscellaneous.map((sm,index)=>(
                <Col md={3} key={index} >
                    <Card className="text-bg-dark text-center" data-aos="flip-up" data-aos-duration="1000">
                    <Card.Img src={mtImage} alt={appLanguage === 'hi' ? (sm.sm_display_en === "1" ? sm.sm_name_hi || '' : sm.sm_name_hi || sm.sm_name) : sm.sm_name} />
                        <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center bg-dark bg-opacity-75'>
                            <Card.Title>{appLanguage === 'hi' ? (sm.sm_display_en === "1" ? sm.sm_name_hi || '' : sm.sm_name_hi || sm.sm_name) : sm.sm_name}</Card.Title>
                            <span dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,sm.miscFile,sm.miscFileHi)}} />
                            {sm.sm_link && <a href={sm.sm_link} target="_blank" rel="noopener noreferrer" className="btn btn-light mt-3">
                                {appLanguage === 'hi' ? "यहाँ क्लिक करें" : "Click Here"}
                            </a>}
                        </Card.ImgOverlay>
                    </Card>
                </Col>
                ))}
            </Row>
        )}
        </React.Fragment>
    );
}